import tmhRequest from '@/config/tmhRequest'

export default {

    searchRefundCardOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundcardorder/searchrefundcardorder',
            method: 'post',
            params: data,
        })
    },

    searchRefundCardOrderCount: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundcardorder/searchrefundcardordercount',
            method: 'post',
            data: data,
        })
    },

    searchRefundCardOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundcardorder/searchrefundcardorderbypage',
            method: 'post',
            data: data,
        })
    },

    initRefundCardOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundcardorder/initrefundcardorder',
            method: 'post',
            params: data,
        })
    },

    createRefundCardOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundcardorder/createrefundcardorder',
            method: 'post',
            data: data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/ispa/order/refundcardorder.js